


























import Vue from 'vue';
import layout from '@/libs/layout/educational/lesson.ts';
import { Component } from 'vue-property-decorator';
import { TLessonPage, PLessonPage } from '@/types/views/educational';
import { getLessonPage } from '@/api/educational';
import { TLayout, TPage } from '@/types/utils';

// interface TMessage {

// }

@Component({})
export default class Lesson extends Vue {
  private layout: TLayout = layout;
  private page: TPage = {
    currentPage: 1,
    pageSize: 50
  };
  private searchOption: PLessonPage = {
    courseId: '',
    pageSize: 50,
    currentPage: 1
  };
  private mounted() {
    this.getLessonList();
  }
  private activated() {
    this.getLessonList();
  }
  private goToLessonDetail(id: string) {
    this.$router.push({
      name: 'lesson-detail',
      params: {
        id
      },
      query: {
        courseId: this.$route.params.id
      }
    });
  }
  private async getLessonList() {
    this.searchOption = {
      ...this.searchOption,
      ...{ courseId: this.$route.params.id }
    };
    try {
      this.page = await getLessonPage(this.searchOption);
    } catch (e) {
      this.$message.error(e.message);
    }
  }
}
